import {
    useEffect,
    useState,
} from 'react';

import {
    useDispatch,
    useSelector,
} from 'react-redux';
import { PermissionAction } from 'src/actions/permission.acction';
import { KhoAction } from 'src/actions/kho.action';

import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormGroup,
    TextField,
    Typography,
    Grid,
    Box,
    Select as Select1,
    InputAdornment,
    SvgIcon,
    MenuItem,
} from '@material-ui/core';

import Select from 'react-select';

import { Search as SearchIcon } from 'react-feather';

import {
    DatePicker,
    LocalizationProvider,
  } from '@mui/x-date-pickers';
  import {
    DEFAULT_ROW_PER_PAGE,
    POST_EDITOR_FONTS,
    POST_EDITOR_FONT_SIZES,
    MAXIMUM_IMAGES,
    MAXIMUM_PRICES,
  } from 'src/utils/constants';
  import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import moment from 'moment';

import PostEditor from "../../components/PostEditor";
import ImageUploader from "../../components/ImageUploader";
import { KhophieuAction } from 'src/actions/khophieu.action';

const CreateEditDialog = (props) => {
    const dispatch = useDispatch()
    const [selectedPermissionIds, setSelectedPermissionIds] = useState([]);
    const { role } = useSelector(state => state.profile);
    const { selected } = useSelector(state => state.kho)

    const [so_phieu, setSoPhieu] = useState("");
    const [ma_san_pham, setMaSanPham] = useState("");
    const [thong_tin_them, setThongTinThem] = useState("");
    const [pro_id, setProId] = useState("-99");
    const [pro_name, setProName] = useState("");
    const [pro_select, setProSelect] = useState(undefined);
    const [price_id, setPriceId] = useState("-99");
    const [price_name, setPriceName] = useState("");
    const [price_select, setPriceSelect] = useState(undefined);
    const [nhap_xuat, setNhapXuat] = useState(0);
    const [ghi_chu, setGhiChu] = useState("");
    const [proList, setProList] = useState([]);
    const [proPriceList, setProPriceList] = useState([]);

    const additionalOptionProduct = { 'id': '-99', 'name': 'Sản phẩm...' };
    const additionalOptionProductprice = { 'id': '-99', 'name': 'Phiên bản...' };

    useEffect(() => {
        async function fetchData() {
            const _proList = await dispatch(KhoAction.proList());
            if (_proList && typeof _proList.data !== 'undefined' && typeof _proList.data.values !== 'undefined') setProList(_proList.data.values);
        }
        fetchData();
    }, [])

    useEffect(() => {
        if (props.type === 'CREATE') {
            resetState();
        }

        if (props.khophieu) {
            setSoPhieu(props.khophieu.so_phieu);
        }
    }, [props])

    useEffect(() => {
        if (props.type === 'EDIT') {
            if (selected) {
                setNhapXuat(selected.nhap_xuat)
                setGhiChu(selected.ghi_chu)
                setMaSanPham(selected.ma_san_pham)
                setThongTinThem(selected.thong_tin_them)

                if (!props.khophieu && typeof selected.khophieu_ref !== 'undefined' && typeof selected.khophieu_ref.so_phieu !== 'undefined') {
                    setSoPhieu(selected.khophieu_ref.so_phieu);
                }

                if (typeof selected.productprice_ref !== 'undefined' && typeof selected.productprice_ref.product_ref !== 'undefined' && typeof selected.productprice_ref.product_ref.prices !== 'undefined') {
                    // setProPriceList(
                    //     [...selected.productprice_ref.product_ref.prices].sort((a, b) => {
                    //         const aHasName = a.name && a.name.trim() !== '';
                    //         const bHasName = b.name && b.name.trim() !== '';
                        
                    //         if (aHasName && !bHasName) return -1;
                    //         if (!aHasName && bHasName) return 1;
                        
                    //         return a.index - b.index;
                    //     })
                    // );
                    setProPriceList(
                        selected.productprice_ref.product_ref.prices
                            .filter(item => item.name && item.name.trim() !== '')
                            .sort((a, b) => a.index - b.index)
                    );
                    setProId(selected.productprice_ref.product_ref.id);
                    setProName(selected.productprice_ref.product_ref.name);
                    setProSelect(selected.productprice_ref.product_ref);
                    setPriceId(selected.productprice_ref.id);
                    setPriceName(selected.productprice_ref.name);
                    setPriceSelect(selected.productprice_ref);
                }
            }
        }
    }, [selected])

    const handleUpdatePriceList = async (pro_select) => {
        setPriceId("-99");
        setPriceName("");
        setPriceSelect(undefined);
        
        if (pro_select && typeof pro_select.prices !== 'undefined') {
            // setProPriceList(
            //     [...pro_select.prices].sort((a, b) => {
            //         const aHasName = a.name && a.name.trim() !== '';
            //         const bHasName = b.name && b.name.trim() !== '';
                
            //         if (aHasName && !bHasName) return -1;
            //         if (!aHasName && bHasName) return 1;
                
            //         return a.index - b.index;
            //     })
            // );
            setProPriceList(
                pro_select.prices
                    .filter(item => item.name && item.name.trim() !== '')
                    .sort((a, b) => a.index - b.index)
            );
        }
    }

    const onPressPositive = async () => {
        if (so_phieu.trim() === "") {
            alert("Vui lòng nhập số phiếu!");
            return;
        }

        if (price_id.trim() === "" || price_id.trim() === "-99") {
            alert("Vui lòng chọn sản phẩm và phiên bản!");
            return;
        }

        if (nhap_xuat.trim() === "" || parseInt(nhap_xuat.trim()) === 0) {
            alert("Vui lòng nhập số lượng nhập/xuất!");
            return;
        }

        if (props.type === 'EDIT') {
            dispatch(KhoAction.update(selected.id, { 
                ma_san_pham: ma_san_pham ? ma_san_pham : "",
                thong_tin_them: thong_tin_them ? thong_tin_them : "",
                so_phieu,
                price_id,
                nhap_xuat,
                ghi_chu: ghi_chu ? ghi_chu : "",
            }))

            if (props.khophieu) {
                dispatch(KhophieuAction.findOne(props.khophieu.id));
            }

            resetState();
            props.handleClose();
        } else {
            try {
                const response = await dispatch(KhoAction.create({ 
                    ma_san_pham: ma_san_pham ? ma_san_pham : "",
                    thong_tin_them: thong_tin_them ? thong_tin_them : "",
                    so_phieu,
                    price_id,
                    nhap_xuat,
                    ghi_chu: ghi_chu ? ghi_chu : "",
                }))

                if (props.khophieu) {
                    dispatch(KhophieuAction.findOne(props.khophieu.id));
                }
                
                resetState();
                props.handleClose();
            } catch (error) {
                if (typeof error.code !== 'undefined' && typeof error.msg !== 'undefined') alert("[Lỗi]\n"+error.msg)
            }
        }
    }

    const resetState = () => {
        setSoPhieu("");
        setMaSanPham("");
        setThongTinThem("");
        setProId("-99");
        setProId("-99");
        setProName("");
        setProSelect(undefined);
        setPriceId("-99");
        setPriceName("");
        setPriceSelect(undefined);
        setNhapXuat("0");
        setGhiChu("");
    }

    const handleSelectOne = (event, id) => {
        const selectedIndex = selectedPermissionIds.indexOf(id);
        let newSelectedCustomerIds = [];
        if (selectedIndex === -1) {
            newSelectedCustomerIds = newSelectedCustomerIds.concat(selectedPermissionIds, id);
        } else if (selectedIndex === 0) {
            newSelectedCustomerIds = newSelectedCustomerIds.concat(selectedPermissionIds.slice(1));
        } else if (selectedIndex === selectedPermissionIds.length - 1) {
            newSelectedCustomerIds = newSelectedCustomerIds.concat(selectedPermissionIds.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelectedCustomerIds = newSelectedCustomerIds.concat(
                selectedPermissionIds.slice(0, selectedIndex),
                selectedPermissionIds.slice(selectedIndex + 1)
            );
        }
        setSelectedPermissionIds(newSelectedCustomerIds);
    };

    const setColor = (value) => {
        if (value == 'cho_duyet') return 'orange';
        else if (value == 'da_duyet') return 'green';
        else if (value == 'tu_choi') return 'red';
        else if (value == 'positive') return 'green';
        else if (value == 'negative') return 'red';
        else return '#000000';
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Dialog className='modal-content-no-scroll' open={props.open} onClose={props.handleClose}>
                <DialogTitle>{props.type === 'EDIT' ? "Cập nhật bản ghi" : "Tạo bản ghi mới"}</DialogTitle>
                <DialogContent className='modal-content-no-scroll' style={{ width: 600, paddingTop: 20 }}>
                    <Grid
                        container
                        spacing={3}
                    >
                        <Grid
                            item
                            md={12}
                            xs={12}
                        >
                            {!props.khophieu ? <TextField
                                fullWidth
                                label="Số phiếu"
                                name="so_phieu"
                                onChange={(e) => setSoPhieu(e.target.value)}
                                required
                                value={so_phieu}
                                variant="outlined"
                            /> : <TextField
                                fullWidth
                                label="Số phiếu"
                                name="so_phieu"
                                required
                                disabled
                                value={so_phieu}
                                variant="outlined"
                            />}
                        </Grid>
                        <Grid
                            item
                            md={12}
                            xs={12}
                        >
                            <div style={{ width: '100%', zIndex: '10', marginTop: 0 }} className="full-width-select">
                                <Select
                                classNamePrefix="nt-select"
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: base => ({
                                        ...base,
                                        zIndex: 999999,
                                    }),
                                    control: (provided) => ({
                                        ...provided,
                                        height: 56,
                                        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                                    }),
                                    option: (provided) => ({
                                        ...provided,
                                        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                                    }),
                                }}
                                options={[additionalOptionProduct, ...proList]} // Thêm vào đầu danh sách
                                getOptionLabel={(item) =>
                                    `${item.name}`
                                }
                                placeholder={(pro_id !== '-99' ? pro_name : 'Sản phẩm...') || "Sản phẩm..."}
                                components={{
                                    DropdownIndicator: () => <SearchIcon size={16} color="action" />,
                                    IndicatorSeparator: null,
                                }}
                                value={pro_id || null}
                                onChange={(newValue) => { setProId(newValue.id); setProName(newValue.name); setProSelect(newValue); handleUpdatePriceList(newValue); }}
                                isSearchable
                                />
                            </div>
                        </Grid>
                        <Grid
                            item
                            md={12}
                            xs={12}
                        >
                            <div style={{ width: '100%', zIndex: '10', marginTop: 0 }} className="full-width-select">
                                <Select
                                classNamePrefix="nt-select"
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: base => ({
                                        ...base,
                                        zIndex: 999999,
                                    }),
                                    control: (provided) => ({
                                        ...provided,
                                        height: 56,
                                        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                                    }),
                                    option: (provided) => ({
                                        ...provided,
                                        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                                    }),
                                }}
                                options={[additionalOptionProductprice, ...proPriceList]} // Thêm vào đầu danh sách
                                getOptionLabel={(item) =>
                                    `${item.name}`
                                }
                                placeholder={(price_id !== '-99' ? price_name : 'Phiên bản...') || "Phiên bản..."}
                                components={{
                                    DropdownIndicator: () => <SearchIcon size={16} color="action" />,
                                    IndicatorSeparator: null,
                                }}
                                value={price_id || null}
                                onChange={(newValue) => { setPriceId(newValue.id); setPriceName(newValue.name); setPriceSelect(newValue) }}
                                isSearchable
                                />
                            </div>
                        </Grid>
                        <Grid
                            item
                            md={12}
                            xs={12}
                        >
                            <TextField
                                fullWidth
                                label="Mã sản phẩm"
                                name="ma_san_pham"
                                onChange={(e) => setMaSanPham(e.target.value)}
                                value={ma_san_pham}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid
                            item
                            md={12}
                            xs={12}
                        >
                            <TextField
                                fullWidth
                                label="Thông tin thêm"
                                name="thong_tin_them"
                                onChange={(e) => setThongTinThem(e.target.value)}
                                value={thong_tin_them}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid
                            item
                            md={12}
                            xs={12}
                        >
                            <TextField
                                fullWidth
                                label="Nhập (+) / Xuất (-)"
                                name="nhap_xuat"
                                onChange={(e) => setNhapXuat(e.target.value)}
                                required
                                value={nhap_xuat}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid
                            item
                            md={12}
                            xs={12}
                        >
                            <TextField
                                fullWidth
                                label="Ghi chú"
                                name="ghi_chu"
                                onChange={(e) => setGhiChu(e.target.value)}
                                value={ghi_chu}
                                variant="outlined"
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.handleClose}>Huỷ</Button>
                    <Button onClick={onPressPositive}>{props.type === 'EDIT' ? "Cập nhật" : "Tạo"}</Button>
                </DialogActions>
            </Dialog >
        </LocalizationProvider>
    );
}

export default CreateEditDialog;